import React from 'react';

import Framework from "@beardeddevops/react.framework";
import ScheduleApprovalsComponent from "components/Collections/ScheduleApprovals"

const breadcrumbStatic = [{
	name: 'Contractor Schedules',
	url: '/managers/approvals',
	icon: 'dashboard'
}];

export default class ScheduleApprovalsContainer extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<ScheduleApprovalsComponent history={history} />
			</div>
		)
	}
}